// import axios from 'axios'

export const Alert = {
    // get: () => axios.get('/api/alerts/1/')
    get: () => {}
}
